const getters = {
    sidebar: (state) => state.app.sidebar,
    permissionRoutes: (state) => state.permission.routes,
    isMobile: (state) => state.app.device === "mobile",
};

export default getters;
